import React from 'react'
import SbEditable from 'storyblok-react'
import cx from 'classnames'

import TextRenderer from './../TextRenderer'
import Components from './../Components'

import styles from './styles.module.scss'

const Copy = (props) => {

    const copyClasses = cx({
        [styles['copy']]: true,
        [styles['copy--max-width']]: props.blok.max_width,
        [styles['copy--center']]: props.blok.text_align == 'center',
        [styles['copy--right']]: props.blok.text_align == 'right'
    })

    return (
        <SbEditable content={props.blok}>
            <TextRenderer text={props.blok.text} className={copyClasses} />
            {props.blok.bottom && props.blok.bottom.map((blok, i) => {
                return (
                    <div key={i} className={styles['copy__bottom']}>
                        {React.createElement(Components(blok.component), {
                            key: blok._uid, 
                            blok: blok
                        })}
                    </div>
                )
            })}
        </SbEditable>
    )
}

export default Copy
